/**
 * useTeamChatAvailable — false when the business's plan doesn't include
 * team chat (the API answers 403 with code PLAN_FEATURE), so the menu can
 * hide Team Chat instead of opening a screen that only shows an error.
 * Unknown / still loading / any other error → true (don't hide on doubt).
 */
import { useQuery } from "@tanstack/react-query";
import api from "@/services/api";
import useAuthStore from "@/stores/authStore";

export function useTeamChatAvailable(): boolean {
  const userId = useAuthStore((s) => s.user?.id);
  const q = useQuery({
    queryKey: ["team-chat-available", userId],
    enabled: !!userId,
    staleTime: 10 * 60_000,
    retry: false,
    queryFn: async () => {
      try {
        await api.get("/chat/users");
        return true;
      } catch (err) {
        const code = (err as { response?: { data?: { code?: string } } })?.response?.data?.code;
        return code !== "PLAN_FEATURE";
      }
    },
  });
  return q.data ?? true;
}

export default useTeamChatAvailable;
